/**
 * Text of the cursor-following hint while dragging a dockable window.
 * @param {boolean} ctrlKey
 * @param {string|null} targetTitle - host under the cursor (only found with Ctrl)
 * @returns {string}
 */
export function dockHintText(ctrlKey, targetTitle) {
    if (!ctrlKey) return 'Hold Ctrl to dock';
    if (!targetTitle) return 'Drag onto a window to dock';

    return `Release to dock in ${targetTitle}`;
}
